import React from "react";
import { Props } from "./types";

function AddColumnAfterIcon({ className }: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="16"
      height="16"
    >
      <rect x="3" y="3" width="12" height="18" rx="1" />
      <line x1="3" y1="9" x2="15" y2="9" />
      <line x1="3" y1="15" x2="15" y2="15" />
      <line x1="9" y1="9" x2="9" y2="21" />
      <line x1="20" y1="3" x2="20" y2="9" />
      <line x1="17" y1="6" x2="23" y2="6" />
    </svg>
  );
}

export { AddColumnAfterIcon };
